import { CardProps } from '../CardContainer/CardContainer';
import * as S from './style';
const CardNotice = ({ children }: CardProps) => <S.CardNoticeContainer>{children}</S.CardNoticeContainer>;

export default CardNotice;
